<td class="align-middle">
  <reference-image [reference]="detail.reference"></reference-image>
</td>
<td class="align-middle text-left">
  <div>
    {{ detail.reference.title }}
    <a class="ml-2" [routerLink]="['/inventory/reference', detail.reference.isbn]" target="_blank">
      <i class="bi bi-card-heading"></i>
    </a>
  </div>
  <div>
    <small>{{ detail.reference.isbn }}</small>
  </div>
  <div>
    <small *ngIf="price">
      <span>{{ price / 100 | currency }}</span>
      <span *ngIf="priceOverride">
        <i class="ml-1 mr-1 bi bi-arrow-right"></i>
        <span class="badge badge-warning">Surchargé à {{ priceOverride / 100 | currency }}</span>
      </span>
      <span *ngIf="priceChange">
        <i class="ml-1 mr-1 bi bi-arrow-right"></i>
        <span class="badge badge-danger">Nouveau prix à {{ priceChange / 100 | currency }}</span>
      </span>
    </small>
  </div>
</td>
<td class="align-middle">{{ detail.receivedQuantity }}</td>
<td class="align-middle">
  <span class="d-none d-sm-block">{{ detail.orderedQuantity }}</span>  
</td>
<td class="align-middle">{{ detail.shippedQuantity }}</td>
<td class="align-middle">
  <span *ngIf="showReceived">
    <button class="btn btn-sm btn-primary" (click)="togglePrintLabel(detail)" *ngIf="isPrintLabelEnabled(detail)">
      <span class="bi bi-check2-square "></span>
    </button>
    <button class="btn btn-sm" (click)="togglePrintLabel(detail)" *ngIf="!isPrintLabelEnabled(detail)">
      <span class="bi bi-square"></span>
    </button>
  </span>
</td>
<td class="align-middle actions">
  <span 
    class="spinner-border spinner-border-sm" 
    *ngIf="showReceived && detail.updating"
  ></span>
  <span class="sr-only">Deleting...</span>
  <button 
    class="btn bi-trash" 
    (click)="removeDetails(detail)" 
    *ngIf="showReceived && !detail.updating"
    [attr.disabled]="readOnly ? 'disabled' : null"
  ></button>
</td>